import React, { useEffect } from "react";
import Invoice from "./Invoice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getspecificSale } from "../../../store/AsyncMethods/SalesMethod";
import {
  getAllVarients,
  getProducts,
} from "../../../store/AsyncMethods/ProductMethod";
import { getspecificPurchase } from "../../../store/AsyncMethods/PurchaseMethod";
import { RESET_SPECIFIC_SALES } from "../../../store/Types/SalesTypes";
import { useReactToPrint } from "react-to-print";
import {
  getCategory,
  getSubCategory,
} from "../../../store/AsyncMethods/CategoryMethod";

export default function PurchaseInvoiceMain() {
  const { user } = useSelector((state) => state.AuthReducer);

  const dispatch = useDispatch();
  const { purchaseId } = useParams();
  useEffect(() => {
    if (purchaseId) {
      dispatch(getspecificPurchase(purchaseId));
    }
  }, []);
  useEffect(() => {
    dispatch(getProducts());
    dispatch(getCategory());
    dispatch(getSubCategory());
  }, []);

  const navigate = useNavigate();
  const handlePrint = useReactToPrint({
    content: () => document.getElementById("receipt-component"),
    // onBeforePrint: () => {
    //   window.close();
    // },
    onAfterPrint: () => {
      dispatch({ type: RESET_SPECIFIC_SALES });
      navigate(user?.role_id == 1 ? "/purchase" : "/purchase-purchase");
    },
    // onBeforePrint: () => navigate(-1),
  });
  useEffect(() => {
    const timer = setTimeout(() => {
      handlePrint();
    }, 1000); // 10 seconds delay in milliseconds

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, []);
  return (
    <div>
      <div className="bg-white w-full mx-auto h-screen">
        {/* <div className="text-center mb-3">
          <button onClick={handlePrint}>Print Receipt</button>
        </div> */}
        <div id="receipt-component">
          <Invoice />
        </div>
      </div>
    </div>
  );
}
